import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./authentication/page404/page404.component";
import { AuthGuard } from "./core/guard/auth.guard";
import { Role } from "./core/models/role";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { UpadeAnnouncementComponent } from "./church-activities/modules/announce/upade-announcement/upade-announcement.component";
const routes: Routes = [
  {
    path: "",
    redirectTo: "/authentication/signin",
    pathMatch: "full"
  },
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "admin",
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin,
        },
        loadChildren: () =>
          import("./admin/admin.module").then((m) => m.AdminModule),
      },
      {
        path: "bank-dashboard",
        canActivate: [AuthGuard],
        data: {
          role: Role.isBankAdmin,
        },
        loadChildren: () =>
          import("./user/user.module").then((m) => m.UserModule),
      },
      // {
      //   path:"bank-branch-dashboard",
      //   canActivate: [AuthGuard],
      //   data: {
      //     role: Role.BranchAdmin,
      //   },
      //   loadChildren: () =>
      //     import("./bank-officer/bank-officer.module").then((m) => m.BankOfficerModule)
      // },
      {
        path: "account",
        loadChildren: () => import("./account/account.module").then(m => m.AccountModule)
      },
      {
        path: "staff-management",
        loadChildren: () => import("./staff-management/staff-management.module").then(m => m.StaffManagementModule)
      },
      {
        path: 'petty-cash',
        loadChildren: () => import('./admin/modules/petty-cash/petty-cash.module').then(m => m.PettyCashModule)
      },
      
      {
        path: "bank-officer",
        loadChildren: () => import("./bank-officer/bank-officer.module").then(m => m.BankOfficerModule)
      },
      {
        path: "church-configuration",
        loadChildren: () => import("./church-configuration/church-configuration.module").then(m => m.ChurchConfigurationModule)
      },
      {
        path: "shirika",
        loadChildren: () => import("./shirika/shirika.module").then(m => m.ShirikaModule)
      },
      {
        path: "institutions",
        loadChildren: () => import("./institutions/institutions.module").then(m => m.InstitutionsModule)
      },
      
      
      {
        path: "self-help-group",
        loadChildren: () => import("./self-help-group/self-help-group.module").then(m => m.SelfHelpGroupModule)
      },
      {
        path: "finance-configuration",
        loadChildren: () => import("./finance-configuration/finance-configuration.module").then(m => m.FinanceConfigurationModule)
      },
      {
        path: "audits",
        loadChildren: () => import("./audits/audits.module").then(m => m.AuditsModule)
      },
      {
        path: "reports",
        loadChildren: () => import("./reports/reports.module").then(m => m.ReportsModule)
      },
      {
        path: "commons",
        loadChildren: () =>
          import("./commons/commons.module").then((m) => m.CommonsModule),
      },
      {
        path: 'church-activities/announce/update-announcement/:id',
        component: UpadeAnnouncementComponent
      },
      {
        path: "church-activities",
        loadChildren: () =>
          import("./church-activities/church-activities.module").then((m) => m.ChurchActivitiesModule),
      },
      {
        path: "mass",
        loadChildren: () =>
          import("./mass/mass.module").then((m) => m.MassModule),
      },
      {
        path: "mpesa",
        loadChildren: () =>
          import("./mpesa/mpesa.module").then((m) => m.MpesaModule),
      },
      {
        path: "church-congregation",
        loadChildren: () =>
          import("./church-congregation/church-congregation.module").then((m) => m.ChurchCongregationModule),
      },

      {
        path: "attendance-tracking",
        loadChildren: () =>
          import("./attendance-tracking/attendance-tracking.module").then((m) => m.AttendanceTrackingModule),
      },
      {
        path: "projects",
        loadChildren: () =>
          import("./projects/projects.module").then((m) => m.ProjectsModule),
      },
      {
        path: "diocese-projects",
        loadChildren: () =>
          import("./diocese-projects/diocese-projects.module").then((m) => m.DioceseProjectsModule),
      },
    ],
  },


  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },

  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { 
    relativeLinkResolution: "legacy",
    useHash: true 
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
